import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AlertType } from '../../components/molecules/Alert';

/** A way out on the toast that opens the support chat with a draft. Plain data, so it can live in the store. */
export interface AlertSupportChat {
	label: string;
	entryPoint: string;
	draft?: string;
	/**
	 * Plan change request: the button asks for the change to this plan and takes
	 * the user into the conversation; `entryPoint` and `draft` are the fallback
	 * (the chat draft) if the request fails.
	 */
	planChange?: { targetProductVersionId: number; requestEntryPoint: string; message: string };
}

export interface AlertState {
	showAlert: boolean;
	type: AlertType;
	description: string;
	title?: string;
	duration?: number;
	supportChat?: AlertSupportChat;
}

export type AlertPayload = {
	type: AlertType;
	description: string;
	title?: string;
	duration?: number;
	supportChat?: AlertSupportChat;
};

const initialState: AlertState = {
	showAlert: false,
	type: 'info',
	description: '',
	title: '',
	duration: 5000,
};

export const alertSlice = createSlice({
	name: 'Alert',
	initialState,
	reducers: {
		showAlert: (state, action: PayloadAction<AlertPayload>) => {
			state.type = action.payload.type;
			state.description = action.payload.description;
			state.title = action.payload.title;
			state.duration = action.payload.duration ?? 5000;
			state.supportChat = action.payload.supportChat;
			state.showAlert = true;
		},
		hideAlert: (state) => {
			state.showAlert = false;
		},
	},
});

export const { showAlert, hideAlert } = alertSlice.actions;
